'use client';

import {
  Box,
  Flex,
  useSlotRecipe,
  type FlexProps,
  type RecipeVariantProps,
} from '@chakra-ui/react';

import type { JSX } from 'react';

import { preloaderRecipe } from './recipe';

export interface IPreloaderProps
  extends RecipeVariantProps<typeof preloaderRecipe> {
  wrapperProps?: FlexProps;
}

export function Preloader({
  variant,
  wrapperProps,
}: IPreloaderProps): JSX.Element {
  const recipe = useSlotRecipe({
    variant,
    recipe: preloaderRecipe,
  });

  const { container, content } = recipe();

  return (
    <Flex css={container} {...wrapperProps}>
      <Box css={content} />
    </Flex>
  );
}
